module.exports = __webpack_public_path__ + "img/u87.71182caf.jpg";